import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const MOCK_WEATHER = [
  { site: 'Swift Current', temp: 18, high: 22, low: 6, wind: 15, windDir: 'NW', humidity: 42, precip: 0, condition: 'Sunny', icon: '☀️', seedingOk: true, forecast: [{day:'Tue',hi:24,lo:8,icon:'☀️',precip:0},{day:'Wed',hi:21,lo:7,icon:'⛅',precip:0},{day:'Thu',hi:16,lo:4,icon:'🌧️',precip:12},{day:'Fri',hi:14,lo:3,icon:'🌧️',precip:8},{day:'Sat',hi:19,lo:5,icon:'⛅',precip:0}] },
  { site: 'Melville', temp: 16, high: 20, low: 4, wind: 22, windDir: 'W', humidity: 48, precip: 0, condition: 'Partly Cloudy', icon: '⛅', seedingOk: true, forecast: [{day:'Tue',hi:22,lo:6,icon:'⛅',precip:0},{day:'Wed',hi:19,lo:5,icon:'⛅',precip:2},{day:'Thu',hi:14,lo:2,icon:'🌧️',precip:15},{day:'Fri',hi:12,lo:1,icon:'🌧️',precip:10},{day:'Sat',hi:17,lo:4,icon:'☀️',precip:0}] },
];

export default function WeatherPage() {
  const [weather] = useState(MOCK_WEATHER);
  useEffect(function() { /* Future: fetch from weather API via supabase edge function */ }, []);

  return (
    <div className="page-container">
      <div className="page-header" style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ margin: 0, color: 'var(--text)' }}>Weather</h1>
        <p style={{ margin: '4px 0 0', color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Farm site conditions - Saskatchewan</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '1.5rem' }}>
        {weather.map(function(w) {
          return (
            <div key={w.site} className="card" style={{ background: 'var(--surface)', borderRadius: '12px', overflow: 'hidden' }}>
              <div style={{ padding: '1.5rem', borderBottom: '1px solid var(--border)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                  <div>
                    <h2 style={{ margin: 0, color: 'var(--text)' }}>{w.site}</h2>
                    <span style={{ background: w.seedingOk ? '#22c55e22' : '#ef444422', color: w.seedingOk ? '#22c55e' : '#ef4444', padding: '2px 10px', borderRadius: '8px', fontSize: '0.8rem', fontWeight: 600 }}>{w.seedingOk ? 'Seeding OK' : 'Seeding Hold'}</span>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '3rem' }}>{w.icon}</div>
                    <div style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>{w.condition}</div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem', marginBottom: '1rem' }}>
                  <span style={{ fontSize: '3.5rem', fontWeight: 700, color: 'var(--text)' }}>{w.temp}</span>
                  <span style={{ fontSize: '1.5rem', color: 'var(--text-secondary)' }}>°C</span>
                  <span style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginLeft: '1rem' }}>H:{w.high}° L:{w.low}°</span>
                </div>
                <div className="stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.75rem' }}>
                  <div style={{ background: 'var(--bg)', borderRadius: '8px', padding: '0.75rem', textAlign: 'center' }}><div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>Wind</div><div style={{ color: 'var(--text)', fontWeight: 600 }}>{w.wind} km/h {w.windDir}</div></div>
                  <div style={{ background: 'var(--bg)', borderRadius: '8px', padding: '0.75rem', textAlign: 'center' }}><div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>Humidity</div><div style={{ color: 'var(--text)', fontWeight: 600 }}>{w.humidity}%</div></div>
                  <div style={{ background: 'var(--bg)', borderRadius: '8px', padding: '0.75rem', textAlign: 'center' }}><div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>Precip</div><div style={{ color: w.precip>0 ? '#3b82f6' : 'var(--text)', fontWeight: 600 }}>{w.precip} mm</div></div>
                </div>
              </div>
              <div style={{ padding: '1rem 1.5rem' }}>
                <h4 style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginBottom: '0.75rem', marginTop: 0 }}>5-DAY FORECAST</h4>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  {w.forecast.map(function(f) {
                    return (
                      <div key={f.day} style={{ flex: 1, textAlign: 'center', padding: '0.5rem', background: 'var(--bg)', borderRadius: '8px' }}>
                        <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem', marginBottom: '0.25rem' }}>{f.day}</div>
                        <div style={{ fontSize: '1.25rem', marginBottom: '0.25rem' }}>{f.icon}</div>
                        <div style={{ color: 'var(--text)', fontSize: '0.8rem', fontWeight: 600 }}>{f.hi}°</div>
                        <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>{f.lo}°</div>
                        {f.precip > 0 && <div style={{ color: '#3b82f6', fontSize: '0.7rem', marginTop: '0.25rem' }}>{f.precip}mm</div>}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}